import React, { useCallback } from 'react';
import { Slider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setRange } from "../../../../../redux/actions/actions";

const SliderAntd = () => {
    const { range } = useSelector(state => state.SliderReducer);
    const dispatch = useDispatch();
    const handleChange = useCallback((value) => dispatch(setRange(value)), [dispatch]);
    return (
        <Slider
            value={range}
            onChange={handleChange}
            min={5}
            max={50}
            className={"slider_antd"}
        />
    );
};

export default SliderAntd;